export default __webpack_public_path__ + "static/media/Initiate's Belt of the Exiled.d7f987af.jpg";